export default "__VITE_ASSET__b0Mv1lSi__"